import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class OptionTypeService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}

	getOptionTypes(payload) {
		return this._http.get(this.baseUrl + '/admin/option_types/', { params: payload.params });
	}

	addOptionTypes(payload) {
		return this._http.post(this.baseUrl + '/admin/option_types/', payload.body);
	}

	updateOptionTypes(payload) {
		return this._http.put(`${this.baseUrl}/admin/option_types/${payload.optionTypeId}/`, payload.body);
	}

	deleteOptionTypes(payload) {
		return this._http.delete(`${this.baseUrl}/admin/option_types/${payload.optionTypeId}/`);
	}
}
